<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/dedication#ded">Dedication</a></p>
<p class="toc-bot"><a href="#/xhtml/acknowledgments#ack">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">Welding with Children</a></p>
<p class="toc"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample">Misuse of Light</span></p>
<p class="toc"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">Good for the Soul</span></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Easy Pickings</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">The Piano Tuner</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">The Pine Oil Writers’ Conference</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Resistance</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Sorry Blood</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Sunset in Heaven</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Rodeo Parole</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Dancing with the One-Armed Gal</span></p>
<p class="toc"><span href="#/xhtml/adcard" title="Link target outside of Sample">Also by Tim Gautreaux</span></p>
<p class="toc"><span href="#/xhtml/copyright" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?00039e3e